import config from "../configuration";

export const getWorkspaceUrl = (workspaceId: string): string | undefined => {
  if (!config["serviceConfig"] || !config["serviceConfig"].hoylu_app) return;
  return `${config["serviceConfig"].hoylu_app}/${workspaceId}`;
};
